import {Router} from '@angular/router';
import {inject,} from "@angular/core";
import {AuthService} from "../../auth/auth.service";


export const isNotConnectedGuard = () => {
  const authService = inject(AuthService)
  const router = inject(Router)
  if (!authService.profile) {
    return true
  } else {
    return router.navigate(['/dashboard'])
  }
}
